import { render, staticRenderFns } from "./ThemeCopyPayPage.vue?vue&type=template&id=083cbd94&scoped=true"
import script from "./ThemeCopyPayPage.vue?vue&type=script&lang=js"
export * from "./ThemeCopyPayPage.vue?vue&type=script&lang=js"
import style0 from "./ThemeCopyPayPage.vue?vue&type=style&index=0&id=083cbd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cbd94",
  null
  
)

export default component.exports